import { colors, Table, TableHeading, TableRow } from '@insurancemenu/imenu-components-lib';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const ContentWrapperStyled = styled.div`
  padding-bottom: 5rem;
`;

export const TableWrapperStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding-bottom: 1rem;
  margin-bottom: 5rem;
  overflow-x: auto;
  box-shadow: ${boxShadows.dark[4]};
`;

export const TableStyled = styled(Table)`
  width: max(100%, 135rem);
`;

export const HeadingsRowStyled = styled(TableRow)`
  border-top: 0.1rem solid ${colors.neutral[500]};
`;

export const TableHeadingStyled = styled(TableHeading)`
  padding: 1.6rem 1rem 1.6rem 0;
  background-color: ${TABLE_HEADER_BG_COLOR};

  &:first-child {
    padding-left: 2.4rem;
  }
`;
